import { render, staticRenderFns } from "./MisDatos.vue?vue&type=template&id=304ead38&"
import script from "./MisDatos.vue?vue&type=script&lang=js&"
export * from "./MisDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports